import CountryAssetsModel from "../../../../Global/Models/Assets/CountryAssetsModel";

export default class FootballCountryModel {
  id: string = "";
  alias: string = "";
  countryCode = "";
  assets: CountryAssetsModel = null;
  name: string = "";
}
